export default __webpack_public_path__ + "static/ukraine-7445eeee73eac7d78785972548ac58e7.png";